import React from "react";
import { FaEnvelope, FaLinkedin, FaMapMarkerAlt, FaLink } from "react-icons/fa";
import "./ExecutiveTemplate.css";

const ExecutiveTemplate = ({ resumeData }) => {
  if (!resumeData) return <div className="em-loading">Loading...</div>;

  const {
    personal = {},
    education = [],
    experience = [],
    skills = { technical: [], soft: [], languages: [] },
    achievements = [],
    certifications = [],
  } = resumeData;

  return (
    <div className="em-a4-container">
      {/* CENTERED HEADER */}
      <header className="em-header">
        <h1 className="em-name">{personal.fullName || "YOUR NAME"}</h1>
        <p className="em-role">
          {personal.title || "The role you are applying for?"}
        </p>

        <div className="em-contact-row">
          {personal.email && (
            <span>
              <FaEnvelope /> {personal.email}
            </span>
          )}
          {personal.linkedin && (
            <span>
              <FaLinkedin /> LinkedIn/Portfolio
            </span>
          )}
          {personal.address && (
            <span>
              <FaMapMarkerAlt /> {personal.address}
            </span>
          )}
        </div>
      </header>

      {/* SUMMARY SECTION */}
      {personal.summary && (
        <section className="em-section">
          <h3 className="em-section-title">Summary</h3>
          <div className="em-summary-box">
            <p>{personal.summary}</p>
          </div>
        </section>
      )}

      {/* EXPERIENCE SECTION */}
      {experience.length > 0 && (
        <section className="em-section">
          <h3 className="em-section-title">Experience</h3>
          {experience.map((exp, idx) => (
            <div key={idx} className="em-exp-item">
              <div className="em-item-row">
                <span className="em-bold">{exp.company || "Company Name"}</span>
                <span className="em-light">{exp.location || "Location"}</span>
              </div>
              <div className="em-item-row">
                <span className="em-italic">{exp.title || "Title"}</span>
                <span className="em-light">
                  {exp.startDate} — {exp.current ? "Present" : exp.endDate}
                </span>
              </div>
              <ul className="em-list">
                {exp.description?.split("\n").map((line, i) => (
                  <li key={i}>{line}</li>
                ))}
              </ul>
            </div>
          ))}
        </section>
      )}

      {/* SKILLS & LANGUAGES GRID */}
      <div className="em-grid-2col">
        <section className="em-section">
          <h3 className="em-section-title">Skills</h3>
          <div className="em-skills-wrap">
            {[...skills.technical, ...skills.soft].map((skill, i) => (
              <span key={i} className="em-skill-dot">
                {skill}
              </span>
            ))}
          </div>
        </section>

        {skills.languages?.length > 0 && (
          <section className="em-section">
            <h3 className="em-section-title">Languages</h3>
            {skills.languages.map((lang, i) => (
              <div key={i} className="em-lang-row">
                <span>{lang}</span>
                <span className="em-dots">●●●●○</span>
              </div>
            ))}
          </section>
        )}
      </div>

      {/* EDUCATION & ACHIEVEMENTS */}
      <section className="em-section">
        <h3 className="em-section-title">Education</h3>
        {education.map((edu, i) => (
          <div key={i} className="em-edu-block">
            <div className="em-item-row">
              <span className="em-bold">{edu.institution}</span>
              <span className="em-light">{edu.location}</span>
            </div>
            <div className="em-item-row">
              <span>{edu.degree}</span>
              <span className="em-light">{edu.year}</span>
            </div>
          </div>
        ))}
      </section>

      {achievements.length > 0 && (
        <section className="em-section">
          <h3 className="em-section-title">Key Achievements</h3>
          <div className="em-ach-grid">
            {achievements.map((ach, i) => (
              <div key={i} className="em-ach-card">
                <p className="em-bold">{ach.split(" ")[0]} Achievement</p>
                <p className="em-small">{ach}</p>
              </div>
            ))}
          </div>
        </section>
      )}
    </div>
  );
};

export default ExecutiveTemplate;
